interface ConfirmNeededIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function ConfirmNeededIcon({ size = 16, ...props }: ConfirmNeededIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M9.2 9.2a3 3 0 0 1 5.7 1c0 2-2.9 2.6-2.9 4" />
      <path d="M12 17.5h.01" />
    </svg>
  );
}
